import { render, staticRenderFns } from "./BookingAlertMarkTalentCompleted.vue?vue&type=template&id=4c94176c"
import script from "./BookingAlertMarkTalentCompleted.vue?vue&type=script&lang=js"
export * from "./BookingAlertMarkTalentCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports